export default __webpack_public_path__ + "static/media/frame_corner_bottom_left_gray.06fbe8f2.png";